import { Outlet, createFileRoute } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { m } from "@/paraglide/messages.js";

/**
 * Names the client in the breadcrumb on every client page, not just the overview: Clients > Adam
 * Nowak > Diet. The same request feeds the page, so this also warms its cache.
 */
export const Route = createFileRoute("/(private)/trainees/$clientId")({
  loader: async ({ params }) => {
    const { data } = await sdk.booking.clients.$clientId.overview.$get.setParams({ clientId: params.clientId }).send();
    return { crumb: data?.client.name ?? m.booking_client_page_crumb() };
  },
  component: Outlet,
});
